import AppShell from "../components/layout/AppShell";
import VigiaEventList from "../components/vigia/VigiaEventList";

export default function VigiaPage() {
  return (
    <AppShell activePage="vigia" title="VIGIA - Monitoramento">
      <div className="space-y-6" data-testid="vigia-page">
        <div>
          <h1 className="text-2xl font-bold text-[#0A2F3D]">VIGIA</h1>
          <p className="text-sm text-gray-400">Monitoramento e observabilidade do sistema</p>
        </div>
        <VigiaEventList />
      </div>
    </AppShell>
  );
}
